var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#0AC79A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0564 31.537L23.9706 29.4431C24.7842 27.5798 26.2486 26.0964 28.0753 25.2856L30.5916 24.1686C31.3916 23.8135 31.3916 22.6496 30.5916 22.2945L28.1538 21.2124C26.2802 20.3807 24.7895 18.8425 23.9899 16.9155L23.0638 14.6841C22.7202 13.856 21.576 13.856 21.2324 14.6841L20.3063 16.9155C19.5066 18.8425 18.0159 20.3807 16.1423 21.2124L13.7045 22.2945C12.9045 22.6496 12.9045 23.8135 13.7045 24.1686L16.2209 25.2856C18.0476 26.0964 19.512 27.5798 20.3255 29.4431L21.2398 31.537C21.5912 32.3418 22.705 32.3418 23.0564 31.537ZM32.2095 36.6353L32.4666 36.046C32.925 34.9954 33.7505 34.1588 34.7805 33.7012L35.5726 33.3492C36.001 33.1589 36.001 32.5363 35.5726 32.346L34.8249 32.0137C33.7683 31.5443 32.928 30.6768 32.4775 29.5905L32.2135 28.9537C32.0294 28.51 31.4159 28.51 31.2318 28.9537L30.9679 29.5905C30.5175 30.6768 29.6772 31.5443 28.6206 32.0137L27.8728 32.346C27.4444 32.5363 27.4444 33.1589 27.8728 33.3492L28.6649 33.7012C29.695 34.1588 30.5204 34.9954 30.9787 36.046L31.2359 36.6353C31.424 37.0666 32.0213 37.0666 32.2095 36.6353Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStart);
export default __webpack_public_path__ + "static/media/aiStart.a87af792c04618017566fdd7b218de57.svg";
export { ForwardRef as ReactComponent };